import {
  ProfileCard,
  ProfileCardHeader,
  ProfileLineWrapper,
} from "@/pages/profile/components/atom";
import { ProfileLine } from "@/pages/profile/components/profile-line";
import UnbindModal from "@/pages/profile/components/action-modal/unbind-modal";
import { BindMiniProgramModal } from "@/pages/profile/components/action-modal/bind-miniprogram-modal";
import request from "project-config/services/request/request";
import { BindOperate } from "@/pages/profile/constant/mini-program";
import { message } from "antd";
import { queryClient } from "@/index";
import { useTranslation } from "react-i18next";
import { useBindAccount } from "@/pages/profile/hooks/useBindAccount";
import { ThirdParty } from "project-config/constants/third-party";
import styled from "styled-components";
import { useMemo } from "react";

export function ThreePartyBinding() {
  const { t } = useTranslation("profile");

  const {
    bindList,
    bindAccount,
    openUnbindModal,
    unbindAccount,
    setUnbindAccount,
    setOpenUnbindModal,
    unbindModalTitle,
    unbindModalContent,
    bindAccountMeta,
    openBindMiniModal,
    setOpenBindMiniModal,
    miniProgramBindList,
    openMiniProgramBind,
    setOpenMiniProgramBind,
  } = useBindAccount();

  const miniProgramActionList = useMemo(() => {
    const actionList = [<div>{t("scan_bind")}</div>];
    if (miniProgramBindList.length > 0) {
      actionList.push(
        <div>{openMiniProgramBind ? t("bind_packup") : t("bind_open")}</div>
      );
    }
    return actionList;
  }, [miniProgramBindList, openMiniProgramBind, t]);

  return (
    <TreePartyWrapper>
      <ProfileCardHeader>{t("third_party_binding")}</ProfileCardHeader>
      <ProfileLineWrapper>
        {bindList.map((item) => {
          const metaInfo = bindAccountMeta[item.fromWhere];

          const { nickname, headimgurl } = item;
          const avatar = headimgurl ? (
            <AvatarImg src={headimgurl} />
          ) : undefined;
          const _nickname = item.id
            ? nickname || t("third_party_binding_already")
            : nickname;
          const extra = _nickname ? (
            <NickName>
              {avatar}
              {_nickname}
            </NickName>
          ) : undefined;

          return (
            <ProfileLine
              key={item.id || item.fromWhere}
              title={metaInfo.name}
              extra={extra}
              noneTip={t("no_bind")}
              actionClass={!!item.id ? "unbind" : ""}
              action={[
                <div
                  key={item.id || item.fromWhere}
                  onClick={() => {
                    if (item.id) {
                      setUnbindAccount(item);
                      setOpenUnbindModal(true);
                      return;
                    }
                    if (item.fromWhere === ThirdParty.MiniProgram) {
                      setOpenBindMiniModal(true);
                      return;
                    }
                    bindAccount(item.fromWhere);
                  }}
                >
                  {item.id
                    ? (t("unbind") as string)
                    : item.fromWhere === ThirdParty.MiniProgram
                    ? (t("scan_bind") as string)
                    : (t("bind") as string)}
                </div>,
              ]}
            />
          );
        })}
        <ProfileLine
          title={bindAccountMeta[ThirdParty.MiniProgram].name}
          extra={
            miniProgramBindList.length > 0 ? (
              <span style={{ color: "#717475" }}>
                {t("miniprogram_bind_num", { 0: miniProgramBindList.length })}
              </span>
            ) : undefined
          }
          noneTip={t("no_bind")}
          action={miniProgramActionList}
          onClick={[
            () => setOpenBindMiniModal(true),
            () => setOpenMiniProgramBind(!openMiniProgramBind),
          ]}
        />
        {openMiniProgramBind &&
          miniProgramBindList.length > 0 &&
          miniProgramBindList.map((item) => {
            const { nickname, headimgurl } = item;
            const extra = (
              <NickName>
                <AvatarImg src={headimgurl} />
                <span>{nickname}</span>
              </NickName>
            );
            return (
              <ProfileLine
                key={item.id}
                extra={extra}
                className="mini-program-box"
                action={[
                  <div
                    key={item.id}
                    onClick={() => {
                      if (item.id) {
                        setUnbindAccount(item);
                        setOpenUnbindModal(true);
                        return;
                      }
                    }}
                  >
                    {t("unbind")}
                  </div>,
                ]}
              />
            );
          })}

        <UnbindModal
          modalProps={{
            type: "text",
            title: unbindModalTitle,
            children: unbindModalContent,
            open: openUnbindModal,
            onCancel: () => setOpenUnbindModal(false),
            onOk: async () => {
              const { code } = await request.post(
                "/api/rendering/user/wxbind/bindWxToUser",
                {
                  bindType: BindOperate.Cancel,
                  id: unbindAccount?.id,
                }
              );
              if (code === 200) {
                message.success(t("user_binded_unbind_hint"));
                await queryClient.invalidateQueries(
                  "/api/rendering/user/wxbind/getBindWx"
                );
              }
              setOpenUnbindModal(false);
            },
          }}
        />
        <BindMiniProgramModal
          modalProps={{
            open: openBindMiniModal,
            title: t("bind_mini"),
            onCancel: () => setOpenBindMiniModal(false),
          }}
        />
      </ProfileLineWrapper>
    </TreePartyWrapper>
  );
}

const NickName = styled.div`
  color: var(--main-color);
  line-height: 22px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const AvatarImg = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 8px;
`;

const TreePartyWrapper = styled(ProfileCard)`
  // min-width: 600px;
`;
